<template>
  <div>
    <h1 class="common__main-title">My Page</h1>
    <component :is="currentDashboard"/>
  </div>
</template>

<script>
import TutorDashboard from '@/components/parts/mypage/dashboard/TutorDashboard.vue';
import AdminDashboard from '@/components/parts/mypage/dashboard/AdminDashboard.vue';
import SeniorDashboard from '@/components/parts/mypage/dashboard/SeniorDashboard.vue';
import PartTimerDashboard from '@/components/parts/mypage/dashboard/PartTimerDashboard.vue';

export default {
  computed: {
    currentDashboard() {
      const role = this.$store.state.auth.profile.authority;
      switch (role) {
        case 'tutor':
          return TutorDashboard;
        case 'admin':
          return AdminDashboard;
        case 'senior':
          return SeniorDashboard;
        case 'partTimer':
          return PartTimerDashboard;
        default:
          return false;
      }
    },
  },
};
</script>
